import { render, staticRenderFns } from "./CreatePlanCompany.vue?vue&type=template&id=2cf3cfbc"
import script from "./CreatePlanCompany.vue?vue&type=script&lang=js"
export * from "./CreatePlanCompany.vue?vue&type=script&lang=js"
import style0 from "./CreatePlanCompany.vue?vue&type=style&index=0&id=2cf3cfbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports